import './navbar.css'
import { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import Logo from '../../assets/LogoNeuHell.png';
import { useAuth } from '../../utils/authContext';
import { useMobile } from '../../utils/mobileContext';
import { useLogin } from '../../hooks/useLogin';

const Navbar = () => {
    const isMobile = useMobile(1000);
    const [menuOpen, setMenuOpen] = useState(false);
    // eslint-disable-next-line 
    const [dashmenu, setDashmenu] = useState(false);
    const { handleLogout } = useLogin();
    const { isAuthenticated } = useAuth();

    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };

    const navRef = useRef(null);
    const hamburgerRef = useRef(null);

    useEffect(() => {
        if (!isMobile || !menuOpen) return;

        const handleClickOutside = (e) => {
            const navEl = navRef.current;
            const hamEl = hamburgerRef.current;
            if (navEl && !navEl.contains(e.target) && hamEl && !hamEl.contains(e.target)) {
                setMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isMobile, menuOpen]);

    const handleDashmenu = () => {
        setDashmenu(prev => !prev);
    };

    return (
        <nav>
            <div className='logoContainer'>
                <img src={Logo} className='navbarLogo' alt='Logo' />
            </div>

            {isMobile && (
                <div className="hamburger" onClick={toggleMenu} ref={hamburgerRef}>
                    ☰
                </div>
            )}

            <ul ref={navRef} className={`navList ${isMobile && menuOpen ? "open" : ""}`}>
                <li><Link to='/'>Startseite</Link></li>
                <li><Link to='/about'>Über uns</Link></li>
                {!isAuthenticated && <li><Link to='/login'>Anmelden</Link></li>}
                {isAuthenticated && <li onClick={handleDashmenu}><Link to='/dashboard'>Dashboard</Link></li>}
                {isAuthenticated && <li onClick={handleLogout}>Logout</li>}
            </ul>
        </nav>
    );
};

export default Navbar;